import { z } from 'zod/v4'
import { WithHistorySchema, WithIdSchema } from './base-models'

export const PBSTCK_BIDDER_GLOBAL_CONFIG_ID = 'pbstck_bidder_global_config'

export const PbstckBidderGlobalConfigSchema = z.object({
  id: WithIdSchema.shape.id.default(PBSTCK_BIDDER_GLOBAL_CONFIG_ID),
  updatedAt: WithHistorySchema.shape.updatedAt.default(new Date()),
  updatedBy: WithHistorySchema.shape.updatedBy.default('system'),
  enabledBidderCodes: z.array(z.string()).default([]),
})

export const UpsertPbstckBidderGlobalConfigSchema = z.object({
  enabledBidders: z.record(z.string(), z.string().nullable()),
})

export type PbstckBidderGlobalConfig = z.infer<typeof PbstckBidderGlobalConfigSchema>
export type UpsertPbstckBidderGlobalConfig = z.infer<typeof UpsertPbstckBidderGlobalConfigSchema>

export const toUpsertPbstckBidderGlobalConfig = (enabledBidderCodes: readonly string[], catalog: readonly { id: string; tfshapingBidder?: string }[]): UpsertPbstckBidderGlobalConfig => {
  const tfshapingBidderById = new Map(catalog.map((entry) => [entry.id, entry.tfshapingBidder ?? null]))
  return { enabledBidders: Object.fromEntries(enabledBidderCodes.map((code) => [code, tfshapingBidderById.get(code) ?? null])) }
}
